(function () {
    "use strict";
    if (window.__esLbReceiptBooted) return;
    window.__esLbReceiptBooted = true;
    const key = "es_lb_success_v1";
    const destination = "G-RV001Z65QW";
    const started = Date.now();
    let done = false;
    function deliver() {
        if (done) return;
        try {
            const raw = window.sessionStorage.getItem(key);
            if (!raw) { done = true; return; }
            const receipt = JSON.parse(raw);
            if (!receipt || !Number.isFinite(receipt.at) || Date.now() - receipt.at > 300000 || receipt.at > Date.now() + 1000) {
                window.sessionStorage.removeItem(key); done = true; return;
            }
            if (window.ES_LB_ANALYTICS_DISABLED || window.Shopify?.designMode ||
                (window.Shopify?.theme && window.Shopify.theme.role !== "main" && !window.ES_LB_ANALYTICS_PREVIEW)) {
                window.sessionStorage.removeItem(key); done = true; return;
            }
            const privacy = window.Shopify?.customerPrivacy;
            if (typeof privacy?.analyticsProcessingAllowed === "function" && !privacy.analyticsProcessingAllowed()) {
                window.sessionStorage.removeItem(key); done = true; return;
            }
            const configured = (window.dataLayer || []).some(row => row && row[0] === "config" && row[1] === destination);
            if (window.Shopify?.theme && privacy?.analyticsProcessingAllowed?.() === true && typeof window.gtag === "function" && configured) {
                const src = receipt.data || {};
                const data = {send_to: destination, lb_version: "1763", page_location: window.location.origin + window.location.pathname, page_referrer: "", page_title: "Shopping cart", transport_type: "beacon"};
                const enums = {
                    lb_step: ["type", "method", "prescription", "reading_strength", "lens", "review", "unknown"],
                    lb_path: ["frame_only", "non_prescription", "readers", "single_vision", "progressive", "bifocal", "unselected"],
                    lb_source: ["cart", "quickview", "product"], lb_mode: ["edit", "new"]
                };
                for (const [name, values] of Object.entries(enums)) if (values.includes(src[name])) data[name] = src[name];
                if (/^[a-zA-Z0-9-]{1,80}$/.test(src.lb_run_id || "")) data.lb_run_id = src.lb_run_id;
                if (/^\d{1,20}$/.test(src.lb_product_id || "")) data.lb_product_id = src.lb_product_id;
                for (const name of ["lb_attempt", "lb_elapsed_ms"]) if (Number.isFinite(src[name]) && src[name] >= 0 && src[name] <= 86400000) data[name] = src[name];
                // Consume once, before calling external code. Reloads never resend.
                window.sessionStorage.removeItem(key); done = true;
                window.gtag("event", "lens_builder_success", data);
                return;
            }
            if (Date.now() - started < 10000) window.setTimeout(deliver, 250);
            else { window.sessionStorage.removeItem(key); done = true; }
        } catch (_) {
            done = true;
            try { window.sessionStorage.removeItem(key); } catch (_) {}
        }
    }
    deliver();
})();
